<script setup lang="ts">
import type { GroupProps } from "./group.types";
import { useGroup } from "./useGroup";

const props = withDefaults(defineProps<GroupProps>(), {
  orientation: "horizontal",
  size: "md",
});

const { classes, contentRef } = useGroup({ props });

defineExpose({ contentRef });
</script>

<template>
  <div
    ref="contentRef"
    part="base"
    :class="classes"
    class="e-group"
    :data-group-size="props.size"
    :data-group-orientation="props.orientation"
  >
    <slot />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
